<template>
  <div class="hello">
    <div class="img1">他们都在用大米智课</div>
    <img
      style="margin-bottom: 24px"
      src="../assets/official/Frame 89.png"
      alt=""
      class="img4"
    />
    <img
      style="margin-bottom: 24px"
      src="../assets/official/Frame 86.png"
      alt=""
      class="img4"
    />
    <img
      style="margin-bottom: 88px"
      src="../assets/official/Frame 88.png"
      alt=""
      class="img4"
    />
  </div>
</template>

<script>
export default {
  name: 'Costing',
  data() {
    return {
      list: [
        {
          content:
            '大米智课量身定制的云学院APP，帮助我们在线统一管理员工培训，考试和晋升，解决了异地管理存在的问题，极大的提高了效率。',
          title: '沃尔沃汽车大中华区销售公司副总裁',
        },
        {
          content:
            '大米智课帮助我们补全了移动端缺失这一块短板，通过分销市场将课程分发给合作伙伴，实现了多方共赢。',
          title: '北京同仁堂培训总监',
        },
        {
          content:
            '大米智课的直播、OMO培训等功能，成功让我们将传统优势线下教育向线上延伸获得了潜在的合作机会和后续业务发展的启发。',
          title: '今日教育副总裁',
        },
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.fdfd_1 {
  background: url('../assets//HelloWorld/cahngjing/23.png');
  background-size: 100% 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 32px 0 165px;
}
.fdfd {
  margin: 48px 0 0 0;
  font-size: 14px;
}

.fdfd1 {
  display: flex;
  justify-content: end;
  align-items: center;
  margin: 0 0 20px;
}

.fdfd12 {
  width: 62px;
  height: 1px;
  margin: 0 10px 0 0;
  background: #929292;
}

.fdfd13 {
  color: #929292;
  font-size: 14px;
}

::v-deep .oooss .el-carousel__container {
  height: 144px;
  width: 1200px;
}

::v-deep .oooss .el-carousel__indicators--outside .is-active button {
  width: 8px;
  border-radius: 50%;
  background: #eb5b05;
  height: 8px;
}

::v-deep .oooss .el-carousel__indicators--outside button {
  width: 8px;
  border-radius: 50%;
  background: #000000;
  height: 8px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #fff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #fff;
}

.hello {
  background-color: #fff;
  // height: 1120px;
  width: 1440px;
  // text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .img1 {
    height: 66px;
    font-size: 36px;
    font-weight: 500;
    color: #121221;
    line-height: 66px;
    margin-bottom: 60px;
  }

  .img2 {
    height: 40px;
    font-size: 24px;
    font-weight: 500;
    color: #121221;
    line-height: 40px;
    margin-bottom: 30px;
  }

  .img4 {
    width: 1161px;
    // transform: scale(1);
    // transition: all 0.3s ease;
  }
  // .img4:hover{
  //     transform: scale(1.1);
  //     transition: all 0.3s ease;
  // }

  .img3 {
    height: 56px;
    font-size: 40px;
    font-weight: 500;
    color: #121221;
    line-height: 56px;
    margin: 60px 0 14px;
  }
}
</style>
